'use strict';

//external
import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Col } from 'external/react-bootstrap';

//react web
import { FlagComponent } from 'plugin/liferay-widgets-react-web';
//base
import ObjectDates from './ObjectDates';
//plugins
import { FeatureDisplayPlugin, Map, PrintPlugin } from 'plugin/map-portlet';

/**
 * Position right column in master-detail view
 * @param selectedItem
 * @param selectedDataItem
 */
const FliwasObjectMasterDetailPosition = ({ selectedItem, selectedDataItem }) => {

    return (
        <Col lg={4} md={4} sm={12} xs={12} className="nopadding">
            <div className="padding-box">

                <FlagComponent item={selectedItem}>
                    <h4>Position</h4>
                    <Map
                        defaultFallbackMapConfigType={'static'}
                        plugins={[FeatureDisplayPlugin, PrintPlugin]}
                        features={[selectedDataItem]}
                        zoom={12}
                    />

                    <ObjectDates dataItem={selectedItem}/>
                </FlagComponent>
            </div>
        </Col>
    );
};

FliwasObjectMasterDetailPosition.propTypes = {
    selectedItem: PropTypes.object.isRequired,
    selectedDataItem: PropTypes.object.isRequired
};

export default FliwasObjectMasterDetailPosition;



// WEBPACK FOOTER //
// ./js/components/FliwasObjectMasterDetailPosition.jsx